import { fromJS } from 'immutable';
import * as actions from '../actions/global';
import { ERROR, START, SUCCESS } from '../actions/utils';
import { defaultPageSize, fetchingState } from '../constants';

const initialStats = {
  user: {},
  configuration: {},
  clientConfig: {
    state: null,
    data: {
      showLastYearTaxes: 0,
    },
  },
  searchResultConfig: {},
  propertyList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
  },
  taxingUnit: {},
  currentYear: {
    data: '',
    state: null,
  },
  importStatus: {
    data: '',
    state: null,
  },
  property: {},
  token: '',
  queryString: '',
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return state.set('user', fromJS(action.data.user));
    case actions.LOGOUT:
      return state.set('user', fromJS({}));
    case actions.CONFIG_FETCH_START:
      return state.setIn(['clientConfig', 'state'], fetchingState.FETCHING);
    case actions.CONFIG_FETCH_SUCCESS:
      return state
        .setIn(['clientConfig', 'state'], fetchingState.LOADED)
        .setIn(['clientConfig', 'data'], fromJS(action.data.results));
    case actions.CONFIG_FETCH_ERROR:
      return state.setIn(['clientConfig', 'state'], fetchingState.ERROR);

    case actions.SEARCH_RESULT_CONFIG_FETCH_START:
      return state.setIn(
        ['searchResultConfig', 'state'],
        fetchingState.FETCHING,
      );
    case actions.SEARCH_RESULT_CONFIG_FETCH_SUCCESS: {
      const newState = state.setIn(
        ['searchResultConfig', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['searchResultConfig', 'data'],
        fromJS(action.data.results),
      );
    }
    case actions.SEARCH_RESULT_CONFIG_FETCH_ERROR:
      return state.setIn(['searchResultConfig', 'state'], fetchingState.ERROR);

    case actions.SEARCH_START:
      return state.setIn(['propertyList', 'state'], fetchingState.FETCHING);
    case actions.SEARCH_SUCCESS: {
      const newState = state.setIn(
        ['propertyList', 'state'],
        fetchingState.LOADED,
      );
      const withTotalCount = newState.setIn(
        ['propertyList', 'totalCount'],
        action.data?.totalProperty ? action.data.totalProperty.propCount : 0,
      );
      return withTotalCount.setIn(
        ['propertyList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    }
    case actions.SEARCH_ERROR:
      return state.setIn(['propertyList', 'state'], fetchingState.ERROR);

    case actions.CHANGE_CURRENT_PAGE:
      return state.setIn(['propertyList', 'currentPage'], action.data);
    case actions.CHANGE_PAGE_SIZE:
      return state.setIn(['propertyList', 'pageSize'], action.data);
    case actions.CHANGE_SORT_MODEL:
      return state.setIn(['propertyList', 'sortModel'], fromJS(action.data));
    case actions.CHANGE_QUERY_STRING:
      return state.set('queryString', action.data);

    case actions.FETCH_CURRENT_YEAR[START]:
      return state.setIn(['currentYear', 'state'], fetchingState.FETCHING);
    case actions.FETCH_CURRENT_YEAR[SUCCESS]: {
      const newState = state.setIn(
        ['currentYear', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['currentYear', 'data'],
        fromJS(action.data?.results ? action.data.results[0].currYear : ''),
      );
    }
    case actions.FETCH_CURRENT_YEAR[ERROR]:
      return state.setIn(['currentYear', 'state'], fetchingState.ERROR);

    case actions.FETCH_IMPORT_STATUS[START]:
      return state.setIn(['importStatus', 'state'], fetchingState.FETCHING);
    case actions.FETCH_IMPORT_STATUS[SUCCESS]: {
      const newState = state.setIn(
        ['importStatus', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['importStatus', 'data'],
        fromJS(action.data?.results ? action.data.results.importStatus : ''),
      );
    }
    case actions.FETCH_IMPORT_STATUS[ERROR]:
      return state.setIn(['importStatus', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_FETCH_START:
      return state.setIn(['property', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_FETCH_SUCCESS: {
      const newState = state.setIn(['property', 'state'], fetchingState.LOADED);
      return newState.setIn(['property', 'data'], fromJS(action.data.results));
    }
    case actions.PROPERTY_FETCH_ERROR:
      return state.setIn(['property', 'state'], fetchingState.ERROR);

    case actions.TAXING_UNIT_FETCH_START:
      return state.setIn(['taxingUnit', 'state'], fetchingState.FETCHING);
    case actions.TAXING_UNIT_FETCH_SUCCESS: {
      const newState = state.setIn(
        ['taxingUnit', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['taxingUnit', 'data'],
        fromJS(action.data.results),
      );
    }
    case actions.TAXING_UNIT_FETCH_ERROR:
      return state.setIn(['taxingUnit', 'state'], fetchingState.ERROR);

    case actions.TOKEN_FETCH_SUCCESS:
      return state.set('token', action.data.user.token);

    case actions.CONFIGURE:
      return state.mergeIn(['configuration'], fromJS(action.configuration));
    default:
      return state;
  }
};
